// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textBlock[data-v-3679a564]{padding:0 30px 30px;font-style:normal;font-weight:400;font-size:18px;line-height:24px;color:var(--q4s-neutral-600);text-align:center}.textBlock__bookmark[data-v-3679a564]{background:url(/img/icons/bookmark-icon-4.png) no-repeat 50%;background-size:contain;display:block;width:100px;height:75px;margin:0 auto 16px}.textBlock__text[data-v-3679a564]{margin:0 auto;max-width:720px}", ""]);
// Exports
module.exports = exports;
